// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30WZB","colBig":"styles_colBig__2_ko_","colSmall":"styles_colSmall__2CxKj"};